import React from 'react';
import * as styles from './styles/styles.module.scss';
import TrailResultCardShimmer from '../TrailResultCardShimmer';

type TrailRiverShimmerProps = {
  className?: string;
};

const TrailRiverShimmer = ({ className = '' }: TrailRiverShimmerProps): JSX.Element => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.innerContainer}>
        <div className={styles.title} />
        <div className={styles.river}>
          <TrailResultCardShimmer />
          <TrailResultCardShimmer />
          <TrailResultCardShimmer />
          <TrailResultCardShimmer />
        </div>
      </div>
    </div>
  );
};

export default TrailRiverShimmer;
